<template>
  <v-app class="bckcolor">
    <v-container v-if="roleType === 'Administrator'" fluid grid-list-md text-xs-center>
      <v-card flat style="border-radius:10px;padding-top:5px;padding-bottom:5px;border: 2px solid;border-color:#E31E24">
        <v-card-title style="padding:0px">
          <h5>Overview</h5>
          <v-spacer></v-spacer>
        <v-btn @click.stop="logOutDialog = true" round flat style="text-transform: unset !important">
                            <avatar :size="32" :username="loggedInUserName"></avatar>
                           &nbsp;&nbsp;{{loggedInUserName}}
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>

              <v-dialog v-model="logOutDialog" max-width="290" persistent>
                <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;">
                  <v-sheet color="transparent" style="text-align:center">
                    <v-icon color="#0d47a1" :size="40">https</v-icon>
                  </v-sheet>
                  
                  <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

                  <v-card-text style="text-align:center;color:black">Are you sure you want to logout from L2Mtech ?</v-card-text>

                  
                    <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>
                    <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
                </v-card>
              </v-dialog>
        </v-card-title>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>

//import Vue from "vue";
import Avatar from "vue-avatar";
import config from "../../config.json";
import CounsellorDashboard from "../Dashboard/CounsellorDashboard";
export default {
  components: {
    Avatar,
    CounsellorDashboard
  },
  data() {
    return {
      roleType: sessionStorage.roles,
      search: "",
      fromDateModel: false,
      toDateModel: false,
      btnSave: false,
      btnSave1: false,
      refsh: false,

      leads: [],
      leadData:[],
      search: "",
      leadsTableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
          { text: "Counsellor", value: "fullName" },
        { text: "Full name", value: "name" },
        { text: "Date", value: "leadDate" },
        { text: "Source", value: "source" },
        { text: "Level", value: "levelName" },
        { text: "Suggested Countries", value: "countryList" }
      ],

      source: ["Facebook", "Justdial", "Sulekha", "Google", "Instagram", "Website", "Reference std", "Reference bp", "Reference emp", "Data calling", "Filed campaign", "Campus activities", "Leaflets" ],
      selectedSource: null,

      country: null,
      selectedCountry: 0,

      level: null,
      selectedLevel: 0,

      user: null,
      selectedUser: null,

      form: {
        fromDate: null,
        toDate: null
      },
    
      logOutDialog: false,
      loggedInUserName: sessionStorage.loggedInUserName,
      loggedInUserID: sessionStorage.loggedInUserID,
    };
  },

  mounted() {
    this.axios
        .get(config.API + "Leads", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.leads = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });

        this.axios
        .get(config.API + "CounsellorList", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.user = res.data;
        });

        this.axios
        .get(config.API + "Countries", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.country = res.data;
        });

        this.axios
        .get(config.API + "Levels", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.level = res.data;
        });
  },

  methods: {
    onView(item) {
      this.$router.push(`/viewLead/${item.id}`);
    },
    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },

    onSubmit() {
      this.btnSave = true;
        this.axios
          .post(
            config.API + `LeadFilter`,
            {
              counsellorId: this.selectedUser,
              fromDate: this.form.fromDate,
              toDate: this.form.toDate,
              countryId: JSON.parse(this.selectedCountry),
              levelId: JSON.parse(this.selectedLevel),
              source: this.selectedSource
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
          this.leads = res.data;
          this.btnSave = false;
          this.refsh = true;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
    },

    onRefresh() {
      this.btnSave1 = true;
      this.form.fromDate = null;
      this.form.toDate = null;
      this.selectedSource = null;
      this.selectedCountry = 0;
      this.selectedLevel = 0;
      this.selectedUser = null;
      this.refsh = false;

      this.axios
        .get(config.API + "Leads", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.leads = res.data;
          this.btnSave1 = false;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    }
  },

  /* computed: {
    isActiveData: function() {
      return this.leads.filter(srch => {
        return (
          new Date(srch.leadDate) >= new Date(this.form.fromDate) && new Date(srch.leadDate) <= new Date(this.form.toDate)
        );
      });
    },
  }, */
};
</script>

<style scoped>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
.v-card {
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.flashing_effect {
  background-color: green !important;
  /* background-image: linear-gradient(-90deg, #f44336, #280071); */
  /* padding: 12px 15px; */
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
marquee {
  height: 85%;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
.bckcolor {
    position: relative;
    background-color: #ffffff;
    background-image: linear-gradient( 36deg, #fff 0%, #d7e1ec 74%);
    box-shadow: inset 0 2px 5px 0px rgb(0 0 0 / 39%);
}
</style>
